import React from 'react';
import { Table } from 'antd';
import { useSelector } from 'react-redux';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import { humanize } from '@utils/humanizeUtil';
import moment from 'moment-timezone';
import Loading from '@icons/prompt/prompt-summary-loading.svg';
import {
  LoadingText,
  LoadingContainer,
  DimensionTableContainer,
  DimensionName,
  DimensionTableTimeInterval,
} from '../styled';

const TotalText = 'Total';

function GroupByTable({ metricQueryInfo, allMetricsObj, timestamp }) {
  const allDimensions = useSelector(allDimensionsListSelector) as Array<{
    groupBy: string;
    name: string;
  }>;

  if (timestamp && metricQueryInfo && metricQueryInfo.status !== 'done') {
    // cancel scenario
    return null;
  } else if (!(metricQueryInfo && metricQueryInfo.status === 'done')) {
    return (
      <LoadingContainer>
        <Loading />
        <LoadingText>Analyzing...</LoadingText>
      </LoadingContainer>
    );
  }

  const [startTime, endTime] = metricQueryInfo.interval;
  const groupBy = metricQueryInfo.groupBy;
  const data = metricQueryInfo.data;
  const curGroupBy = allDimensions?.find((dim) => {
    return dim.groupBy === groupBy[0];
  });

  const totalObj = data.totals[0].results;
  const dataList = data.data[0].results;

  const columns = [
    {
      title: '',
      dataIndex: groupBy[0],
      key: groupBy[0],
      render(text, record, index) {
        return (
          <span
            style={{
              fontWeight: index === 0 ? 'bold' : 'normal',
              fontStyle: index === 0 ? 'italic' : 'normal',
            }}
          >
            {record.name?.[0] || text}
          </span>
        );
      },
    },
    ...Object.keys(totalObj).map((metricKey) => {
      const curMetric = allMetricsObj[metricKey];
      return {
        title: curMetric?.displayName || metricKey,
        dataIndex: metricKey,
        key: metricKey,
        render(text, record, index) {
          const unit = curMetric?.unit;
          return (
            <span
              style={{
                fontWeight: index === 0 ? 'bold' : 'normal',
                fontStyle: index === 0 ? 'italic' : 'normal',
              }}
            >
              {typeof text === 'number' ? humanize(text, unit) : text}
              {unit}
            </span>
          );
        },
      };
    }),
  ];

  const dataSource = [
    {
      ...totalObj,
      [groupBy[0]]: TotalText,
    },
    ...dataList,
  ];

  return (
    <DimensionTableContainer>
      <DimensionName>
        {curGroupBy?.name || groupBy[0]}
        <DimensionTableTimeInterval>
          {moment(startTime).format('DD  MMM, YYYY HH:mm:ss')} -{' '}
          {moment(endTime).format('DD  MMM, YYYY HH:mm:ss')}
        </DimensionTableTimeInterval>
      </DimensionName>
      <Table columns={columns} dataSource={dataSource} scroll={{ x: true }} pagination={false} />
    </DimensionTableContainer>
  );
}

export default GroupByTable;
